<template>
  <div ref="wrapper">
    <div id="predict-list" ref="jobContainer" :class="['size-'+predictList.length,noWaterfall ? 'row':'waterfall' ]" v-touch:swipe.left="moveNext" v-touch:swipe.right="movePrev">
      <div class="grid-sizer" />
      <div v-for="job in predictList" :key="job.id" :class="noWaterfall? noWaterfallClass : normalClass">
      <a :href="`/job/${getFullSlug(job.jobtitletext,job.id)}`" target="_blank">
        <JobCard
          :id="job.id"
          :is-blind="job.blindAd"
          :priority="job.priority"
          :logo="job.logoname"
          :url="job.url"
          :tag="job.tag"
          :title="job.jobtitletext"
          :company="job.displayname"
          :industry="job.industrydesc"
          :cluster="job.clusterdesc"
          :joblevel="job.managerialleveldesc"
          :employmenttype="job.employmentstatusdesc"
          :salary="concatSalary(job.minsalary,job.maxsalary,job.salarytype,job.showsalary)"
          :location="job.locationdesc"
          :activationdate="job.activationdate"
        />
      </a>
</div>
    </div>
    <a v-if="morelink" :href="morelink" target="blank" class="cp-btn mb-4" style="min-width:86px">More</a>
  </div>
</template>
<script>
import Vue2TouchEvents from 'vue2-touch-events'
import Vue from 'vue'
import JobCard from '~/components/search/JobCard.vue'
import commonHelper from '~/assets/js/commonHelper.js'
Vue.use(Vue2TouchEvents)
export default {
  components: {
    JobCard
  },
  props: {
    type: {
      type: String,
      default: 'predict'
    },
    positionid: {
      type: String,
      default: ''
    },
    noWaterfall: {
      type: Boolean,
      default: false
    },
    maxPredict: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      predictList: [],
      selector: '.waterfall',
      resized: false,
      currentIndex: 0,
      normalClass: 'item col-xs-12 col-sm-12 col-md-4 col-lg-3 mb-3',
      noWaterfallClass: 'item col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-4',
      options: {
        columnWidth: '.grid-sizer',
        percentPosition: true,
        gutter: 0,
        itemSelector: '.item'
      },
      morelink: ''
    }
  },
  mounted() {
    this.getSimilar(this.positionid)
    window.onerror = function (msg, url, lineNo, columnNo, error) {
      // ... handle error ...
      return false
    }
  },
  methods: {
    moveNext: function () {
      if (this.currentIndex <= 2) {
        this.currentIndex += 1
        const itemWidth = this.$refs.jobContainer.querySelectorAll('.item')[0].offsetWidth
        const val = this.currentIndex === 2 ? this.$refs.jobContainer.offsetWidth - this.$refs.wrapper.offsetWidth : itemWidth
        const vm = this
        vm.$refs.wrapper.scrollLeft = val
      }
    },
    movePrev: function () {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1
        const itemWidth = this.$refs.jobContainer.querySelectorAll('.item')[0].offsetWidth
        const val = this.currentIndex === 1 ? itemWidth : 0
        const vm = this
        vm.$refs.wrapper.scrollLeft = val
      }
    },
    getFullSlug(title, id) {
      const fullSlug = commonHelper.getSlug(title) + '-' + id
      return fullSlug
    },
    jobLoaded() {
      if (process.browser) {
        this.loaded += 1
      }
    },
    validateJobs: async function (ids) {
      const vm = this
      await this.$store.dispatch('search/validateJob', ids).catch(function (reason) {
        vm.$emit('failed')
      })
      this.predictList = this.$store.state.search.joblist
      if (this.maxPredict && this.predictList !== undefined) this.predictList = this.predictList.slice(0, Number(this.maxPredict))
      if (this.predictList.length > 0) {
        this.$emit('loaded')
      } else {
        this.$emit('failed')
      }
      this.jobLoaded()
    },
    getSimilar: async function (id) {
      const vm = this
      await this.$store.dispatch('search/fetchSimilarJob', id).catch(function (reason) {
        vm.$emit('failed')
      })
      this.predictList = this.$store.state.search.joblist
      if (this.maxPredict && this.predictList !== undefined) this.predictList = this.predictList.slice(0, Number(this.maxPredict))
      this.morelink = this.$store.state.search.morelink
      if (this.predictList !== undefined && this.predictList.length > 0) {
        this.$emit('loaded')
      } else {
        this.$emit('failed')
      }
      this.jobLoaded()
    },
    concatSalary(min, max, type, show) {
      if (show === 'N') {
        return ''
      }
      let str = ''
      if (min && max) {
        str = min + '-' + max
      } else {
        str = min || max
      }
      if (str !== '' && type) {
        str += ' / ' + type
      }
      if (!str) {
        return ''
      }
      return str.toString()
    }
  }
}
</script>
